module.exports = __webpack_public_path__ + "static/media/S_E01.ff0557de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_E01.png
// module id = 129
// module chunks = 0